import { ScheduleTypes } from './ISchedule';

/**
 * Schedule objects using frequency and frequencyDetails
 * Based on ScheduleHelpers.java in the monolith and "ScheduleType" in REST API as of v3.23 (24.1)
 * All properties should be optional unless marked as required in "ScheduleType"
 * User docs example: extract refresh schedules on Cloud:
 * https://help.tableau.com/current/api/rest_api/en-us/REST/rest_api_ref.htm#create_cloud_extract_refresh_task
 */
export type SelfServiceSchedule = {
    frequency?: ScheduleTypes;
    frequencyDetails?: FrequencyDetails;
    name?: string;
    createdAt?: string;  // ISO 8601 format: YYYY-MM-DDThh:mm:ssZ
    updatedAt?: string;  // ISO 8601 format: YYYY-MM-DDThh:mm:ssZ
    nextRunAt?: string;  // ISO 8601 format: YYYY-MM-DDThh:mm:ssZ
}

export type FrequencyDetails = {
    start: string;  // HH:MM:SS
    end?: string;   // HH:MM:SS
    intervals?: {
        interval: Interval[];
    };
}

export enum WeekDayOccurrence {
    First = 'First',
    Second = 'Second',
    Third = 'Third',
    Fourth = 'Fourth',
    Fifth = 'Fifth',
    LastDay = 'LastDay'
}

export enum WeekDay {
    Sunday = 'Sunday',
    Monday = 'Monday',
    Tuesday = 'Tuesday',
    Wednesday = 'Wednesday',
    Thursday = 'Thursday',
    Friday = 'Friday',
    Saturday = 'Saturday'
}

type IntervalBaseType = {
    minutes?: never;
    hours?: never;
    weekDay?: never;
    monthDay?: never;
}

export type IntervalMinutesType = Omit<IntervalBaseType, 'minutes'> & { minutes: number };
export type IntervalHoursType = Omit<IntervalBaseType, 'hours'> & { hours: 1 | 2 | 4 | 6 | 8 | 12 | 24 };
export type IntervalWeekDayType = Omit<IntervalBaseType, 'weekDay'> & { weekDay: WeekDay };
// MonthDay number values can be 1-31, see RestApiScheduleUtils.validateScheduleRequest()
export type IntervalMonthDayType = Omit<IntervalBaseType, 'monthDay' | 'weekDay'> & { monthDay: WeekDayOccurrence | number, weekDay?: WeekDay };

export type Interval = IntervalMinutesType | IntervalHoursType | IntervalWeekDayType | IntervalMonthDayType;